import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css"; // เรียกใช้ไฟล์ CSS ของ react-circular-progressbar
import "./styles/circular-progressbar.css"; // เรียกใช้ไฟล์ CSS ที่คุณสร้าง
import energy from "/energy.png?url";

const CircularProgressBar = ({ percentage }) => {
  return (
    <>

      <div className="circularBar">
        <div className="circular-progress-container">
          <CircularProgressbarWithChildren
            value={percentage}
            styles={{
              path: {
                stroke: `#53d394`, // สีของบาร์
              },
              trail: {
                stroke: "#d6d6d6", // สีของเส้นของบาร์
              },
            }}
          >
            <div>
              <img
                src={energy}
                alt="energy"
                style={{ width: "30%", height: "auto", marginLeft: "35%" }}
              />
            </div>
            <div style={{ fontSize: "22px", marginTop: "-10px" }}>
              <strong style={{ color: "#53d394" }}>{percentage}%</strong>
            </div>
          </CircularProgressbarWithChildren>
        </div>
      </div>
    </>
  );
};

export default CircularProgressBar;
